import { merge, of, EMPTY, Observable } from 'rxjs';

import Global from '../../../store/global-selectors';
import { LabelBatchStatusStep } from '../../../enums/label-batch-status-step';
import * as EntitiesActions from '../../../store/entities/entities.actions';
import * as PrintActions from '../../../store/batches/print/batches.print.actions';
import { determineShouldShowLabelBatchStatus, shouldLaunchLbsModal } from '../../quickship/quickship.helpers';
import { getBatchMenuData } from '../nav/batches.nav.actions';
import { ModalService } from 'ui-components/services/modal-service';
import history from '../../../history';
import { DEFAULT_ORDERS_PAGE_URL } from '../../../services/user-permission-service';

import {
  BATCH_JOB_ENTITY_GROUP_NAME,
  BATCH_JOB_ENTITIY_ID_ATTRIBUTE,
  BATCH_ENTITY_GROUP_NAME,
  BATCH_ENTITY_ID_ATTRIBUTE,
} from './constants';
import { normalizeDataArray, buildEntityPayload, buildJobData } from './data-helpers';
import * as Actions from './batches.purchase.actions';

export const redirectToOrdersGrid = ({ fulfillmentPlanSetId, quickshipProps, override = false }) => {
  const isLbsModalLaunched = !quickshipProps.shouldUseQuickship || shouldLaunchLbsModal(quickshipProps);
  const isOnBatchStill = window.location.pathname.includes(`/orders/batches/open/${fulfillmentPlanSetId}`);
  if ((!isLbsModalLaunched || override) && isOnBatchStill) {
    history.push({ pathname: DEFAULT_ORDERS_PAGE_URL });
  }
  return EMPTY;
};

export const handleApiSuccess = ({ getState, fulfillmentPlanSetId, labelBatchIds, quickshipProps }) => {
  const batchEntity = Global.selectEntitiesBatchByFulfillmentPlanSetId(getState(), {
    fulfillmentPlanSetId,
  });
  const batchEntityToUpdate = {
    ...batchEntity,
    step: determineShouldShowLabelBatchStatus(quickshipProps)
      ? LabelBatchStatusStep.Processing.ordinal
      : LabelBatchStatusStep.Loading.ordinal,
  };

  const jobData = buildJobData(labelBatchIds, fulfillmentPlanSetId);
  const { jobs, jobIdsToFpSetIdMap } = jobData;

  const normalizedJobs = normalizeDataArray(BATCH_JOB_ENTITY_GROUP_NAME, BATCH_JOB_ENTITIY_ID_ATTRIBUTE, jobs);
  const normalizedBatches = normalizeDataArray(BATCH_ENTITY_GROUP_NAME, BATCH_ENTITY_ID_ATTRIBUTE, [batchEntityToUpdate]);

  const newEntities = buildEntityPayload({
    ...normalizedJobs,
    ...normalizedBatches,
  });

  return of(Actions.createLabelsForBatchesSuccess(fulfillmentPlanSetId, jobIdsToFpSetIdMap), EntitiesActions.entitiesLoad(newEntities));
};

const commonMessageActions = ({ getState, fulfillmentPlanSetId, completedCount, shouldPrint, quickshipProps }) => {
  const batchEntity = Global.selectEntitiesBatchByFulfillmentPlanSetId(getState(), {
    fulfillmentPlanSetId,
  });

  const cleanedBatch = normalizeDataArray(BATCH_ENTITY_GROUP_NAME, BATCH_ENTITY_ID_ATTRIBUTE, [batchEntity], true);
  const entities = buildEntityPayload(cleanedBatch);
  const cleanupActions = [Actions.cleanUpBatchFromState(fulfillmentPlanSetId), EntitiesActions.entitiesLoad(entities), getBatchMenuData()];
  const closeModalObservable$ = new Observable((observer) => {
    if (!determineShouldShowLabelBatchStatus(quickshipProps)) {
      ModalService.closeModalById(Global.selectBatchesPurchaseLabelBatchStatusModalId(getState()));
    }
    observer.complete();
  });

  if (!shouldPrint || completedCount === 0) {
    return merge(of(...cleanupActions), closeModalObservable$);
  }
  return merge(
    of(...cleanupActions, PrintActions.startLabelPrintedCheck([fulfillmentPlanSetId], undefined, false)),
    redirectToOrdersGrid({
      fulfillmentPlanSetId,
      quickshipProps,
      override: true,
    }),
    closeModalObservable$,
  );
};

export const handleSuccessMessage = ({ getState, completedCount, fulfillmentPlanSetId, shouldPrint, quickshipProps }) => {
  return commonMessageActions({
    getState,
    fulfillmentPlanSetId,
    completedCount,
    shouldPrint,
    quickshipProps,
  });
};

export const handleFailureMessage = ({ getState, completedCount, fulfillmentPlanSetId, shouldPrint, quickshipProps }) => {
  return commonMessageActions({
    getState,
    completedCount,
    fulfillmentPlanSetId,
    shouldPrint,
    quickshipProps,
  });
};
